<template>
    <div class="form-elements">
        <!-- #Início# Relatório de Comissão (Colaborador) -->
        <vuestic-modal ref="modalComissoesColaboradores" :cancelClass="'none'" :okClass="'none'">
            <div slot="title">Relatório de Comissões (Colaboradores)</div>
            <comissoesColaboradores></comissoesColaboradores>
        </vuestic-modal>
        <!-- #Fim# Relatório de Comissão (Colaborador) -->
        
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Relatório Comercial">
                    <div class="row">
                        <div class="col-md-4">
                            <vuestic-widget class="info-widget text-center">
                                <div class="info-widget-inner">
                                    <div class="stats">
                                        <div class="stats-number">
                                            <i class="ion ion-ios-document green-arrow stats-icon fa-3x"></i>
                                        </div>
                                        <h3>Relatório de Comissões</h3>
                                        <p>Relatório de comissões de colaboradores</p>
                                        <hr>
                                        <button @click="$refs.modalComissoesColaboradores.open()" class="btn btn-block btn-lg btn-secondary">IR</button>
                                    </div>
                                </div>
                            </vuestic-widget>
                        </div>
                    </div>

                    <!-- #Início# Download -->
                    <a href="#" hidden id="downloadPDF"></a>
                    <!-- #Fim# Download -->
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
  import * as spinners from 'epic-spinners'
  import { ModelSelect } from 'vue-search-select'
  //import urlApi from '../../router/urlApi'

  import ComissoesColaboradores from './modal/administrativo/ComissoesColaboradores'

  export default {
    name: 'relatorioComercial',
    components: {
      ...spinners,
      ModelSelect,
      ComissoesColaboradores
    },
    data () {
      return {
        load: false,
        modal: {
          titulo: '',
          dados: [],
          show: false,
          load: false
        },
        modalDoacao: false,
        download: {
          load: false
        },
        user: '',
      }
    },
    mounted () {
      let email = localStorage.email.split('@')
      this.user = email[0]
    },
    methods: {
    },
  }
</script>